const FilterDevices = {
	desktop: 'desktop',
	mobile: 'mobile',
	all: 'all'
};

export default FilterDevices;